import { lazy, Suspense } from "react";

import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/orderHistory/main"));

const ActivityHistory = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ActivityHistory;
